export default __webpack_public_path__ + "static/media/December2021.9d9c108e.png";